import PopularProductItem from 'gatsby-theme-dettol/src/components/common/PopularProductItem/PopularProductItem';
import './PopularProductItemOverride.scss';

export default PopularProductItem;
